var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHoz(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_5",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 6.665,
    cy: 28.715,
    r: 1.445
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8.701 32.047l.26.427 3.9-2.382-4.593-7.518-3.9 2.382.339.555M31.055 26.706l-18.192 3.382-4.594-7.52 11.17-14.683 11.616 18.821zM12.863 30.088l3.698 6.054"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M31.506 13.472l4.473-2.733M33.056 18.924l5.095 1.231M27.43 9.716l1.231-5.096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHoz);
export default __webpack_public_path__ + "static/media/HOZ.ac23e629d9fc9381597c4744f057ba88.svg";
export { ForwardRef as ReactComponent };